export default __webpack_public_path__ + "static/mainSectionImage-ab989563121b50e4e75fc34a126a1c4b.webp";